import ResendSmsInfo from '@/pages/components/sms-verification/ResendSmsInfo';
import { CtaButton, CtaButtonText, CtaSection } from '@/pages/components/styled/Cta';
import { StyledDialog } from '@/pages/components/styled/Dialog';
import type { PatchPatientForInstantConsultationReply } from '@/pages/NurseConsultation';
import CloseIcon from '@mui/icons-material/Close';
import { Box, DialogContent, DialogTitle, IconButton, Slide, styled } from '@mui/material';
import type { TransitionProps } from '@mui/material/transitions';
import React from 'react';
import { ResendSmsButton } from './ResendSmsButton';

interface ResendSmsVerificationDialogProps {
  open: boolean;
  onClose: () => void;
  onSubmit: () => Promise<PatchPatientForInstantConsultationReply>;
  handleShowCalendar: () => void;
}

const ResendSmsInfoContainer = styled(Box)(() => ({
  flex: 1,
}));

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & { children: React.ReactElement },
  ref: React.Ref<unknown>,
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export const StyledBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  marginBottom: theme.spacing(40),
  [theme.breakpoints.up('sm')]: {
    marginBottom: 0,
  },
}));

const ResendSmsVerificationDialog = ({
  open,
  onClose,
  onSubmit,
  handleShowCalendar,
}: ResendSmsVerificationDialogProps) => {
  return (
    <StyledDialog open={open} onClose={onClose} TransitionComponent={Transition} data-testid="resend-sms-dialog">
      <DialogTitle sx={{ position: 'relative', pr: 5 }}>
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
          data-testid="close-resend-sms-dialog"
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <StyledBox>
        <DialogContent>
          <ResendSmsInfoContainer>
            <ResendSmsInfo />
          </ResendSmsInfoContainer>
          <CtaSection breakpoint="sm">
            <ResendSmsButton onSubmit={onSubmit} />
            <CtaButton
              type="button"
              color="primary"
              size="large"
              variant="outlined"
              onClick={handleShowCalendar}
              data-testid="book-nurse-consultation-for-later-button"
            >
              <CtaButtonText breakpoint="sm">Book a nurse consultation for later</CtaButtonText>
            </CtaButton>
          </CtaSection>
        </DialogContent>
      </StyledBox>
    </StyledDialog>
  );
};

export default ResendSmsVerificationDialog;
